import { Box, Button, MenuItem, TextField, Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";
import CircularProgress from "@mui/material/CircularProgress";
import { useContext, useEffect, useRef, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { SnackbarContext } from "../../App";
import appService from "../../services/app.service";
import ImageCordinates from "./ImageCordinates";
import ImageUpload from "./ImageUpload";
import SelectCoordinatesModal from "./SelectCoordinatesModal";
import { useTranslation } from "react-i18next";
import CustomLoadingButton from "../CustomComponents/CustomsButtons/CustomLoadingButton";

export default function VisualTestForm(props) {
  const { t } = useTranslation();
  const { setSnack } = useContext(SnackbarContext);

  const ScrollRef = useRef();

  const { setState, type, defaultValues, returnValue } = props;
  const {
    handleSubmit,
    register,
    reset,
    setValue,
    setError,
    control,
    formState: { errors },
    getValues,
  } = useForm({ defaultValues });

  const [Imgarea1, setImgarea1] = useState([]);
  const [loading, setLoading] = useState(false);
  const [BaseImage] = useState(defaultValues?.UploadBaseImage ? defaultValues.UploadBaseImage : false);

  const [loadingSubmit, setLoadingSubmit] = useState(false);

  const [file1, setFile1] = useState([]);

  // const ValBaseImageUrl = () => {
  //   setBaseImage(!BaseImage);
  // };

  useEffect(() => {
    if (type === "edit") {
      setFile1(getValues("BaseImage"));
    }
  }, [type]);

  useEffect(() => {
    if (file1) {
      if (file1?.[0]) {
        setValue("BaseImage", file1[0]);
      } else {
        setValue("BaseImage", file1.location);
      }
    }

    if (type === "edit") {
      setImgarea1(getValues("IgnoredAreas"));
    }
  }, [file1]);

  const [imgProps1, setImgProps1] = useState({ width: 0, height: 0 });

  function isValidHttpUrl(string) {
    let url;
    try {
      url = new URL(string);
    } catch {
      return false;
    }
    return url.protocol === "http:" || url.protocol === "https:";
  }
  const ScrolltoTop = () => {
    setTimeout(() => {
      ScrollRef?.current?.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest",
      });
    }, 400);
  };

  const handleSave = async (data) => {
    setLoadingSubmit(true);
    if (BaseImage && !data.BaseImage) {
      setSnack({
        message: "Upload a base image",
        open: true,
        colour: "error",
      });
      ScrolltoTop();
    } else {
      if (data._id) {
        delete data._id;
      }
      data.IgnoredAreas = Imgarea1;
      try {
        await appService.createVisualTest(data);
        reset();
        returnValue(false);
        setSnack({
          message: "Visual Test created",
          open: true,
          colour: "success",
        });
      } catch (err) {
        err?.response?.status === 422 &&
          setError("TestName", {
            type: "custom",
            message: "This test is already exists",
          });
        ScrolltoTop();
      }
    }
    setLoadingSubmit(false);
  };

  const handleEdit = async (data) => {
    setLoading(true);
    if (BaseImage && !data.BaseImage) {
      setSnack({
        message: "Upload a base image",
        open: true,
        colour: "error",
      });
      ScrolltoTop();
    } else {
      data.IgnoredAreas = Imgarea1;
      try {
        await appService.editVisualTest(defaultValues._id, data);
        reset();
        returnValue(false);
        setSnack({
          message: "Visual Test Updated",
          open: true,
          colour: "success",
        });
      } catch (e) {
        setSnack({
          message: e?.response?.data?.message ?? e.message,
          open: true,
          colour: "error",
        });
        ScrolltoTop();
      }
    }
    setLoading(false);
  };

  const createNewButton = loadingSubmit ? (
    <>
      <CircularProgress
        style={{
          width: "20px",
          height: "20px",
          color: "#ffffff",
          marginRight: "8px",
        }}
      />
      {t("Create as New")}
    </>
  ) : (
    t("Create as New")
  );
  return (
    <Box p={2}>
      <Typography sx={{ flex: "1 1 100%", mb: 1 }} variant="h6" component="div">
        {type === "add" ? t("New") : t("Edit")} {t("Visual Test")} :
      </Typography>
      <Grid container spacing={2} ref={ScrollRef}>
        <Grid size={12}>
          <Controller
            name="TestName"
            control={control}
            defaultValue={defaultValues?.TestName}
            rules={{
              required: t("This input is required."),
              minLength: {
                value: 4,
                message: t("Minimum length 4 char"),
              },
              maxLength: {
                value: 32,
                message: t("Maximum length 32 char"),
              },
            }}
            render={({ field }) => (
              <TextField
                {...field}
                fullWidth
                size="small"
                label={t("Test Name")}
                error={Boolean(errors.TestName)}
                helperText={errors?.TestName?.message}
                onChange={(e) => {
                  const cleanedValue = e.target.value.replace(/\s{2,}/g, " ");
                  field.onChange(cleanedValue);
                }}
              />
            )}
          />
        </Grid>
        {BaseImage && (
          <>
            <Grid size={6}>
              <Box className="imgUpMain">
                <Box className="imgDisplay">
                  <SelectCoordinatesModal
                    Imgarea1={Imgarea1}
                    file={file1}
                    setImgarea1={setImgarea1}
                    imgProps1={imgProps1}
                    setImgProps1={setImgProps1}
                    data={{
                      threshold: getValues("Threshold"),
                      Comparison: "Strict",
                      Highlight_Differences: "true",
                      count_to_get: getValues("MaxDifferences"),
                      color: "rgb(255 0 0 / 52%)",
                    }}
                  />
                </Box>
                <ImageUpload setFile={setFile1} file={file1} />
              </Box>
            </Grid>
            <Grid size={6}>
              <ImageCordinates Imgarea1={Imgarea1} setImgarea1={setImgarea1} file1={file1} sizes={false} />
            </Grid>
          </>
        )}
        {errors?.file?.message}
        <Grid size={12}>
          {/* <Box mb="8px" sx={{ "& label": { ml: 0 } }}>
            <Controller
              name="UploadBaseImage"
              control={control}
              render={() => (
                <FormControlLabel
                  {...register("UploadBaseImage", {
                    onChange: () => ValBaseImageUrl(),
                  })}
                  control={
                    <Switch checked={BaseImage} size="small" color="primary" />
                  }
                  label={t("Upload Base Image ?")}
                  labelPlacement="end"
                />
              )}
            />
          </Box> */}
        </Grid>
        <Grid size={6}>
          <TextField
            size="small"
            select
            fullWidth
            label={t("Threshold")}
            name="threshold"
            defaultValue={defaultValues?.Threshold ? defaultValues.Threshold : "50"}
            {...register("Threshold", {
              required: t("This input is required."),
            })}
            error={errors.Threshold}>
            <MenuItem value="50"> 50 </MenuItem>
            <MenuItem value="100"> 100 </MenuItem>
            <MenuItem value="150"> 150 </MenuItem>
            <MenuItem value="200"> 200 </MenuItem>
            <MenuItem value="250"> 250 </MenuItem>
          </TextField>
        </Grid>
        <Grid size={6}>
          <TextField
            type="number"
            fullWidth
            defaultValue="10"
            InputProps={{ inputProps: { min: "1", step: "1" } }}
            error={errors.MaxDifferences}
            {...register("MaxDifferences", {
              required: t("This input is required."),
            })}
            size="small"
            label={t("No. of differences")}
            variant="outlined"
          />
        </Grid>
        <Grid size={12}>
          <Controller
            name="ApplicationUrl"
            control={control}
            defaultValue={defaultValues?.ApplicationUrl}
            rules={{
              required: t("This input is required."),
              validate: (value) => isValidHttpUrl(value) || "Invalid URL format",
            }}
            render={({ field }) => (
              <TextField
                {...field}
                fullWidth
                size="small"
                label={t("Application Url")}
                error={Boolean(errors.ApplicationUrl)}
                helperText={errors?.ApplicationUrl?.message}
                onChange={(e) => {
                  const cleanedValue = e.target.value.replace(/\s{2,}/g, " ");
                  field.onChange(cleanedValue);
                }}
              />
            )}
          />
        </Grid>
        <Grid size={12}>
          <Controller
            name="ApplicationName"
            control={control}
            defaultValue={defaultValues?.ApplicationName}
            rules={{
              required: t("This input is required."),
              minLength: {
                value: 4,
                message: t("Minimum length 4 characters"),
              },
            }}
            render={({ field }) => (
              <TextField
                {...field}
                fullWidth
                size="small"
                label={t("Application Name")}
                error={Boolean(errors.ApplicationName)}
                helperText={errors?.ApplicationName?.message}
                onChange={(e) => {
                  const cleanedValue = e.target.value.replace(/\s{2,}/g, " ");
                  field.onChange(cleanedValue);
                }}
              />
            )}
          />
        </Grid>
      </Grid>
      <Grid container sx={{ m: 1 }} rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
        <Grid size={4} textAlign="left">
          <Button
            variant="outlined"
            color="error"
            size="small"
            onClick={() => {
              setState(false);
            }}>
            {t("Cancel")}
          </Button>
        </Grid>
        <Grid size={4} textAlign="center">
          {type === "edit" && (
            <Button
              variant="contained"
              type="submit"
              size="small"
              sx={{ mr: 1 }}
              disabled={loadingSubmit || loading}
              onClick={handleSubmit(handleSave)}>
              {createNewButton}
            </Button>
          )}
        </Grid>
        <Grid size={4} textAlign="right">
          {type === "edit" ? (
            <CustomLoadingButton
              disabled={loading || loadingSubmit}
              onClick={handleSubmit(handleEdit)}
              color="success"
              sx={{ mr: 1 }}
              loading={loading}
              type="submit">
              {t("Update")}
            </CustomLoadingButton>
          ) : (
            <CustomLoadingButton
              color="success"
              loading={loadingSubmit}
              type="submit"
              sx={{ mr: 1 }}
              disabled={loadingSubmit}
              onClick={handleSubmit(handleSave)}>
              {t("Create")}
            </CustomLoadingButton>
          )}
        </Grid>
      </Grid>
    </Box>
  );
}
